import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useQueryParams } from "src/hooks/useQueryParams";
import { QUERY_PARAM_KEYS } from "src/constants/queryParams";
import { ReactComponent as ArrowDownIcon } from "src/assets/icons/arrow-down.svg";
import { filteringButtonsTrns } from "./trns";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";

interface Props {
  isShownMore: boolean;
}
export const ShowMoreButton: FC<Props> = ({ isShownMore }) => {
  const { t } = useTranslation();

  const { setQueryParam } = useQueryParams();
  const toggleIsShownMore = () => {
    setQueryParam(QUERY_PARAM_KEYS.IS_SHOWED_MORE, (!isShownMore).toString());
  };

  return (
    <Button
      className="flex items-center gap-2 font-semibold"
      variant={ButtonVariants.SECONDARY}
      onClick={toggleIsShownMore}
    >
      <ArrowDownIcon className={cn({ "rotate-180": isShownMore })} />
      {isShownMore
        ? t(filteringButtonsTrns.showLess)
        : t(filteringButtonsTrns.showMore)}
    </Button>
  );
};
